import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import Bar from '../bar';

const formatOptions = data => {
    return data.map(item => ({
        ...item,
        isCheck: false,
    }));
};

class Radio extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        onChange: PropTypes.func,
        showData: PropTypes.bool,
        index: PropTypes.number,
        error: PropTypes.bool,
        disabled: PropTypes.bool,
    };

    state = {
        options: formatOptions(this.props.content.option),
        error: false,
        showData: false,
        disabled: this.props.disabled || false,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resShowData = {};
        let resError = {};
        let resDisabled = {};

        if (props.showData !== state.showData) {
            resShowData = { showData: props.showData };
        }
        if (props.error !== state.error) {
            resError = { error: props.error };
        }
        if (props.disabled !== state.disabled) {
            resDisabled = { disabled: props.disabled };
        }

        return { ...resShowData, ...resError, ...resDisabled };
    };

    handleChange = index => {
        const options = JSON.parse(JSON.stringify(this.state.options));

        options.forEach((item, i) => {
            if (index === i) {
                options[i].isCheck = true;
            } else {
                options[i].isCheck = false;
            }
        });

        this.setState(
            {
                options,
            },
            () => {
                this.callbackRes();
            },
        );
    };

    callbackRes = () => {
        const { options } = this.state;
        const res = [];

        options.forEach(item => {
            if (item.isCheck) {
                res.push(item.itemid);
            }
        });
        this.props.onChange({
            questionid: this.props.content.questionid,
            value: res,
        });
        // console.log(res);
    };

    render() {
        const { content, index } = this.props;
        const { result } = content;
        const { options, error, showData, disabled } = this.state;

        return (
            <div className={styles.checkBox}>
                <h2 className={error ? styles.error : ''}>
                    {`${index + 1}.`}
                    {content.question}
                    {error ? <em className={styles.ismust}>(此问必答)</em> : null}
                </h2>
                {/* options */}
                {options.map((item, index) => {
                    return (
                        <div key={item.itemid} className={styles.option}>
                            <span className={styles.opTxt} style={{ width: showData ? 280 : '100%' }}>
                                <label
                                    className={`${styles.checkLabel} ${
                                        item.isCheck ? styles.checked : styles.noCheck
                                    }`}>
                                    <input
                                        type="radio"
                                        name={`sur[${content.questionid}][]`}
                                        className={styles.hiddenCheckBox}
                                        onChange={this.handleChange.bind(this, index, item.itemid)}
                                        disabled={disabled}
                                    />
                                    <p>{item.title}</p>
                                </label>
                            </span>
                            {showData ? (
                                <div className={styles.sign}>
                                    <div className={styles.signbox}>
                                        <span className={styles.bar}>
                                            <Bar index={index} nump={item.nump} />
                                        </span>
                                        <span className={styles.ct}>{`${item.nump}%`}</span>
                                        <strong className={styles.percent}>{item.num}票</strong>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default Radio;
